import React from "react";
import Logo from "../Assets/logo.png";
import { BsInstagram, BsTelephone, BsTwitter } from "react-icons/bs";
import { SiLinkedin } from "react-icons/si";
import { FaFacebookF } from "react-icons/fa";

const Footer = () => {
  return (
    <div className="bg-gray-900 text-white py-8">
      <div className="container mx-auto px-6 md:px-12 flex flex-col md:flex-row justify-between items-start">
        {/* Logo and Social Icons */}
        <div className="mb-6 md:mb-0">
          <div className="footer-logo-container mb-4">
            <img src={Logo} alt="Logo" className="w-32" />
          </div>
          <div className="footer-icons flex space-x-4">
            <BsTwitter className="text-2xl cursor-pointer hover:text-blue-400" />
            <SiLinkedin className="text-2xl cursor-pointer hover:text-blue-600" />
            <a href="https://www.instagram.com/ngoloservices/profilecard/?igsh=MThuY2tmeGpyOTB5ag%3D%3D">
            <BsInstagram className="text-2xl cursor-pointer hover:text-red-600" />


            </a>
            <a href="https://www.facebook.com/profile.php?id=61567289725014&mibextid=LQQJ4d&rdid=ZrXgj75qDo5moe83&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2FbsL68JSKX1VNWXLt%2F%3Fmibextid%3DLQQJ4d">

            <FaFacebookF className="text-2xl cursor-pointer hover:text-blue-700" />
            </a>
            <a href="https://wa.link/4db76h">
            <BsTelephone className="text-xl cursor-pointer hover:text-blue-700" />
            
            </a>
          </div>
        </div>

        {/* Footer Links */}
        <div className="footer-section-two flex flex-wrap justify-between w-full md:w-auto">
          {/* First Column */}
          <div className="footer-section-columns flex flex-col space-y-2 md:mr-8">
            <span className="hover:underline cursor-pointer">
              Expertise technique combinée à la créativité
            </span>
            <span className="hover:underline cursor-pointer">
              Approche humaine et personnalisée
            </span>
            <span className="hover:underline cursor-pointer">Polyvalence</span>
            <span className="hover:underline cursor-pointer">Flexibilité</span>
          </div>

          {/* Second Column */}
          {/* <div className="footer-section-columns flex flex-col space-y-2 md:mr-8 mt-6 md:mt-0">
            <span>06 98 81 84 32</span>
            <span>hello@ngogo.com</span>
            <span>press@ngolo.com</span>
            <span>contact@Ngolo.com</span>
          </div> */}

          {/* Third Column */}
          <div className="footer-section-columns flex flex-col space-y-2 mt-6 md:mt-0">
            <span className="hover:underline cursor-pointer">
              Terms & Conditions
            </span>
            <span className="hover:underline cursor-pointer">
              Privacy Policy
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
